<template>
  <d-row>
    <d-col cols="12">
      <d-card :class="{ 'mb-4': true, 'comments-block': true, 'is-loading': !commentsLoaded }">
        <d-card-body>
          <h4>Komentarze</h4>

          <d-alert
            v-if="!productID"
            theme="warning"
            show
            class="mt-4">
            Dodawanie komentarzy będzie możliwe po zapisaniu produktu
          </d-alert>

          <div v-if="productID">
            <validation-observer
              ref="commentForm"
              tag="form">
              <div class="form-group">
                <label for="name">
                  Treść komentarza:
                </label>

                <validation-provider
                  rules="required"
                  name="comment"
                  v-slot="{ errors }">
                  <textarea
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    v-model="commentForm.comment"
                    :disabled="commentSubmitInProgress"
                    rows="5"></textarea>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>

                <d-button
                  class="d-block ml-auto mt-3"
                  @click.prevent="validateCommentForm"
                  :disabled="commentSubmitInProgress">
                  <template v-if="commentSubmitInProgress">
                    <span class="spinner-wrapper">
                      <span class="spinner"></span>
                    </span>
                  </template>
                  <template v-else>Skomentuj</template>
                </d-button>
              </div>
            </validation-observer>

            <d-alert
              v-if="!comments.length"
              theme="light"
              show>
              Brak komentarzy do tego produktu
            </d-alert>

            <ol
              v-if="comments.length"
              class="comments-list">
              <li
                v-for="(comment, index) of comments"
                :key="'comment-' + index"
                class="comment">
                <strong class="comment-author">
                  {{ comment.user_name }}
                </strong>

                <small
                  v-if="comment.user_id === currentUserID"
                  :class="{ 'text-danger': true, 'comment-remove': true, 'in-progress': removeCommentInProgress === comment.id }"
                  @click="removeComment(comment.id)">
                  <template v-if="removeCommentInProgress !== comment.id">
                    <i class="material-icons">delete</i> Usuń
                  </template>
                  <template v-else>
                    Usuwanie...
                  </template>
                </small>

                <time class="comment-date">
                  {{ formatDate(comment.created_at) }}
                </time>

                <p class="comment-text">
                  {{ comment.comment }}
                </p>
              </li>
            </ol>
          </div>
        </d-card-body>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';
import { mapGetters } from 'vuex';

export default {
  name: 'product-form-comments',
  props: ['productID'],
  computed: {
    ...mapGetters('user', [
      'currentUserID'
    ]),
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      commentForm: {
        comment: ''
      },
      comments: [],
      commentsLoaded: false,
      removeCommentInProgress: false,
      commentSubmitInProgress: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadComments();
    }
  },
  methods: {
    formatDate (input) {
      input = input.split('T');
      return input[0] + ' ' + input[1].split('.')[0];
    },
    loadComments () {
      this.commentsLoaded = false;

      FormUtils.loadAdditionalData(this, {
        endpoint: '/products/comments/items',
        params: {
          pagination: 0,
          where: {
            product_id: this.productID
          }
        },
        outputKey: 'comments',
        loadedKey: 'commentsLoaded',
        successAction: () => {
          this.commentsLoaded = true;
        }
      });
    },
    validateCommentForm () {
      console.log('Przed walidacją - komentarz:', this.commentForm.comment);
      this.commentSubmitInProgress = true;
      FormUtils.validate(this.$refs.commentForm, this.addComment, () => {
        this.commentSubmitInProgress = false;
      });
    },
    addComment () {
      console.log('W addComment - komentarz:', this.commentForm.comment);
      console.log('Product ID:', this.productID);
      console.log('Cały commentForm:', JSON.stringify(this.commentForm));
      
      // Zapisz komentarz przed wyczyszczeniem
      const commentToSend = this.commentForm.comment;
      
      // Wyczyść formularz i zresetuj walidację od razu
      this.commentForm.comment = '';
      this.$nextTick(() => {
        const observer = this.$refs.commentForm;
        if (observer && typeof observer.resetForm === 'function') {
          observer.resetForm();
        }
      });
      
      FormUtils.submit(this, {
        endpoint: '/products/comments/store',
        formData: {
          comment: commentToSend,
          product_id: this.productID
        },
        successTitle: 'Dodano komentarz',
        successText: '',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Dodawanie komentarza nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.commentSubmitInProgress = false;
          this.loadComments();
        },
        failAction: () => {
          this.commentSubmitInProgress = false;
        }
      });
    },
    removeComment (commentID) {
      this.removeCommentInProgress = commentID;

      ListUtils.removeItem(this, {
        endpointBase: '/products/comments/delete/',
        id: commentID,
        successTitle: 'Usunięto komentarz',
        successText: 'Wybrany komentarz został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten komentarz?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie komentarza nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeCommentInProgress = false;
          this.loadComments();
        },
        cancelAction: () => {
          this.removeCommentInProgress = false;
        },
        failAction: () => {
          this.removeCommentInProgress = false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.spinner {
  animation: spinner 1s linear infinite;
  border: 3px solid #fff;
  border-left-color: transparent;
  border-radius: 50%;
  display: block;
  height: 24px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(0deg);
  width: 24px;

  &-wrapper {
    display: block;
    height: 13px;
    padding: 0 20px;
    position: relative;
    width: 100%;
  }
}

@keyframes spinner {
  from {
    transform: translateX(-50%) translateY(-50%) rotate(0deg);
  }

  to {
    transform: translateX(-50%) translateY(-50%) rotate(360deg);
  }
}

.comments-list {
  list-style-type: none;
  padding: 0;
}

.comment {
  border: 1px solid #eee;
  border-radius: 3px;
  margin: 20px 0;
  padding: 20px;
}

.comment-author {
  font-weight: bold;
}

.comment-remove {
  cursor: pointer;
  margin-left: 10px;
}

.comment-text {
  font-weight: 300;
  margin: 0;
  padding: 10px 0;
}

.comment-date {
  float: right;
  font-size: 12px;
  font-weight: 300;
  line-height: 24px;
}
</style>
